import { render, staticRenderFns } from "./FlushMessage.vue?vue&type=template&id=25c24ac1&scoped=true"
import script from "./FlushMessage.vue?vue&type=script&lang=js"
export * from "./FlushMessage.vue?vue&type=script&lang=js"
import style0 from "./FlushMessage.vue?vue&type=style&index=0&id=25c24ac1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c24ac1",
  null
  
)

export default component.exports